import RestClient from './RestClient';
import { Section } from '../../models';

class Sections extends RestClient {
    constructor() {
        super({
            "model": Section,
            "entryPoint": "section",
            "resource": "section",
            "resources": "sections"
        });

        this.filmSectionOptionsPath = '/film_section_options';
    }

    loadFilmSectionOptions(_params) {
        return this.GET(`/${this.entryPoint}${this.filmSectionOptionsPath}`, {})
            .then(response => response.json())
            .then(json => {
                if (json.film_section_options) {
                    return { filmSectionOptions: json.film_section_options };
                }
                throw new Error(json.flash?.error || 'film_section_options_unavailable');
            });
    }
}

const SectionsApi = new Sections();

export default SectionsApi;
